export default __webpack_public_path__ + "static/media/icon-headphones.06a9d7b4.svg";